export default __webpack_public_path__ + "static/media/2.52fdd538.png";